import { useState } from "react";
import axios from "axios";
import { CalendarHeart, ExternalLink, LayoutGrid, Pencil, Send, Smartphone, Trash2, XCircle } from "lucide-react";
import { toast } from "sonner";
import { API, IG_STATUS, KIND, errText, igImg, when } from "@/components/instagram/common";

const whenText = (p) => (p.status === "scheduled" ? `Paylaşım zamanı: ${when(p.scheduled_at)}` : p.published_at ? `Paylaşıldı: ${when(p.published_at)}` : `Planlanan: ${when(p.scheduled_at)}`);

function Targets({ p }) {
  return (
    <div className="ig-targets">
      {Object.entries(p.targets).map(([k, t]) => (
        <span key={k} className={`ig-target ${t.status}`} data-testid={`ig-target-${k}-${p.id}`}>
          {k === "feed" ? <LayoutGrid size={12} /> : <Smartphone size={12} />}{KIND[k]}
          {t.status === "done" && t.permalink && <a href={t.permalink} target="_blank" rel="noreferrer">Gör <ExternalLink size={10} /></a>}
          {t.error && <em title={t.error}>{t.error}</em>}
        </span>
      ))}
    </div>
  );
}

export function PostCard({ p, connected, onEdit, onChanged }) {
  const [busy, setBusy] = useState(false);
  const act = async (fn, ok) => { setBusy(true); try { await fn(); toast.success(ok); onChanged(); } catch (e) { toast.error(errText(e)); } setBusy(false); };
  const [label, cls] = IG_STATUS[p.status] || [p.status, ""];
  const canPublish = ["scheduled", "failed", "partial", "cancelled"].includes(p.status);
  return (
    <div className="panel ig-card" data-testid={`ig-post-${p.id}`}>
      <img className="ig-thumb" src={igImg(p.image.feed)} alt="" />
      <div className="ig-body">
        <div className="ig-card-top"><span className={`camp-status ${cls}`} data-testid={`ig-post-status-${p.id}`}>{label}</span>{p.source === "special_day" && <span className="ig-source"><CalendarHeart size={12} />Özel gün</span>}</div>
        {p.title && <b className="ig-title">{p.title}</b>}
        <p className="campaign-text">{p.caption || (p.targets.feed ? "Açıklama yok" : "Sadece story")}</p>
        <small className="campaign-when">{whenText(p)}</small>
        <Targets p={p} />
        {p.note && <small className="form-hint warn" data-testid={`ig-post-note-${p.id}`}>{p.note}</small>}
        <div className="campaign-actions">
          {canPublish && <button className="primary-btn" disabled={busy || !connected} title={!connected ? "Önce Instagram hesabını bağlayın" : ""} onClick={() => window.confirm("Şimdi Instagram'da paylaşılsın mı?") && act(() => axios.post(`${API}/instagram/posts/${p.id}/publish`), "Paylaşım başladı")} data-testid={`ig-post-publish-${p.id}`}><Send size={14} />{["failed", "partial"].includes(p.status) ? "Tekrar dene" : "Şimdi paylaş"}</button>}
          {["scheduled", "cancelled"].includes(p.status) && <button className="outline-btn" disabled={busy} onClick={onEdit} data-testid={`ig-post-edit-${p.id}`}><Pencil size={14} />Düzenle</button>}
          {p.status === "scheduled" && <button className="outline-btn" disabled={busy} onClick={() => act(() => axios.post(`${API}/instagram/posts/${p.id}/cancel`), "Gönderi iptal edildi")} data-testid={`ig-post-cancel-${p.id}`}><XCircle size={14} />İptal et</button>}
          {p.status !== "publishing" && <button className="icon-btn danger" disabled={busy} title="Listeden sil" onClick={() => window.confirm(p.status === "done" || p.status === "partial" ? "Kayıt listeden silinsin mi? Instagram'daki paylaşım silinmez." : "Gönderi silinsin mi?") && act(() => axios.delete(`${API}/instagram/posts/${p.id}`), "Silindi")} data-testid={`ig-post-delete-${p.id}`}><Trash2 size={14} /></button>}
        </div>
      </div>
    </div>
  );
}
